import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=a7308fd6&scoped=true&"
import script from "./setup.vue?vue&type=script&setup=true&lang=js&"
export * from "./setup.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./setup.vue?vue&type=style&index=0&id=a7308fd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7308fd6",
  null
  
)

export default component.exports